// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .nav-pills {
    display: flex;
    justify-content: center;
    padding: 10px;
    border-radius: 8px;
}
.nav-pills .nav-link {
    color: #007bff;
    font-weight: bold;
    border-radius: 5px;
    padding: 10px 20px;
    transition: 0.3s ease-in-out;
    margin-right: 10px;
}
.nav-pills .nav-link.active {
    background: #007bff;
    color: white;
}
.nav-pills .nav-link:hover {
    background: #0056b3;
    color: white;
}
.channel-card {
    border-radius: 12px;
    padding: 20px;
    transition: 0.3s ease-in-out;
}
.dashboardChartContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    gap: 2%;
}


.traffic-container { 
    width: 160px; 
    background: #222; 
    padding: 15px; 
    border-radius: 20px; 
    display: flex; 
    flex-direction: row;   
    gap: 15px; 
    align-items: center; 
    justify-content: center;
}



.light {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    opacity: 0.2;
}



.red-light {
    background: red;
}


.yellow-light {
    background: yellow;
}


.green-light {
    background: green;
}


 .blink-red {
    opacity: 1;
    animation: blinkRed 0.8s infinite;
}

.blink-yellow {
    opacity: 1;
    animation: blinkYellow 0.8s infinite;
}

.blink-green {
    opacity: 1;
    animation: blinkGreen 0.8s infinite;
}
.traffic-light-center {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
}



@keyframes blinkRed {

    0% {
        opacity: 1;
        box-shadow: 0 0 20px red, 0 0 40px red;
    }

    50% {
        opacity: 0.3;
        box-shadow: none;
    }

    100% {
        opacity: 1;
        box-shadow: 0 0 20px red, 0 0 40px red;
    }

}


@keyframes blinkYellow {

    0% {
        opacity: 1;
        box-shadow: 0 0 20px rgb(244, 244, 3), 0 0 40px rgb(243, 243, 4);
    }

    50% {
        opacity: 0.3;
        box-shadow: none;
    }

    100% {
        opacity: 1;
        box-shadow: 0 0 20px rgb(246, 246, 5), 0 0 40px rgb(241, 241, 6);
    }

}


@keyframes blinkGreen {

    0% {
        opacity: 1;
        box-shadow: 0 0 20px rgb(6, 232, 6), 0 0 40px rgb(5, 234, 5);
    }

    50% {
        opacity: 0.3;
        box-shadow: none;
    }

    100% {
        opacity: 1;
        box-shadow: 0 0 20px rgb(5, 244, 5), 0 0 40px rgb(5, 243, 5);
    }

}
.statistics-container {
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  justify-content: center;
  margin-bottom: 20px;
  margin-top: -25px;
}

.stats-card {
  background: white;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  text-align: center;
}

.dashboardChart {
    width: 30%; 
    min-width: 280px; 
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
}

@media screen and (max-width: 1200px) {
    .dashboardChart {
        width: 45%; 
    }
}

@media screen and (max-width: 768px) {
    .dashboardChart {
        width: 100%; 
    }
}

.combined-charts-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
}

.combined-chart-container {
  flex: 1;
  width: 100%;
  background-color: white;
  padding: 5px;
  border-radius: 10px;
  box-shadow: 0px 3px 6px rgba(241, 241, 241, 0.1);
  height: 300px;
  overflow: hidden;
}

.combined-chart-container canvas {
  width: 100% !important;
}

@media screen and (max-width: 768px) {
  .combined-charts-row {
    flex-direction: column;
  }

  .combined-chart-container {
    width: 100%;
  }
  .combined-chart-container canvas {
    min-height: 300px;
    width: 100% !important;
  }
}


.top-dashboard-section {
    display: flex;
    flex-direction: column;  
    align-items: center;
    gap: 20px;
} */



/* Channel Tabs */
.nav-pills {
    display: flex;
    justify-content: center;
    padding: 10px;
    border-radius: 8px;
}

.nav-pills .nav-link {
    color: #007bff;
    font-weight: bold;
    border-radius: 5px;
    padding: 10px 20px;
    transition: 0.3s ease-in-out;
    margin-right: 10px;
}

.nav-pills .nav-link.active {
    background: #007bff;
    color: white;
}

.nav-pills .nav-link:hover {
    background: #0056b3;
    color: white;
}


/* Dashboard Layout */
.dashboardChartContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    gap: 2%;
}


/* =========================
   TRAFFIC LIGHT
========================= */

.traffic-container {
    width: 160px;
    background: #222;
    padding: 15px;
    border-radius: 20px;

    display: flex;
    flex-direction: row;     /* Horizontal lights */
    justify-content: center;
    align-items: center;

    gap: 15px;
}


/* Light Circle */

.light {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    opacity: 0.2;
}


.red-light {
    background: red;
}

.yellow-light {
    background: yellow;
}

.green-light {
    background: green;
}


/* Center Traffic Light */

.traffic-light-center {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}


/* =========================
   BLINK ANIMATION
========================= */

.blink-red {
    opacity: 1;
    animation: blinkRed 0.8s infinite;
}

.blink-yellow {
    opacity: 1;
    animation: blinkYellow 0.8s infinite;
}

.blink-green {
    opacity: 1;
    animation: blinkGreen 0.8s infinite;
}


@keyframes blinkRed {

    0% {
        opacity: 1;
        box-shadow: 0 0 20px red, 0 0 40px red;
    }

    50% {
        opacity: 0.3;
        box-shadow: none;
    }

    100% {
        opacity: 1;
        box-shadow: 0 0 20px red, 0 0 40px red;
    }
}


@keyframes blinkYellow {

    0% {
        opacity: 1;
        box-shadow: 0 0 20px yellow, 0 0 40px yellow;
    }

    50% {
        opacity: 0.3;
        box-shadow: none;
    }

    100% {
        opacity: 1;
        box-shadow: 0 0 20px yellow, 0 0 40px yellow;
    }
}


@keyframes blinkGreen {

    0% {
        opacity: 1;
        box-shadow: 0 0 20px green, 0 0 40px green;
    }

    50% {
        opacity: 0.3;
        box-shadow: none;
    }

    100% {
        opacity: 1;
        box-shadow: 0 0 20px green, 0 0 40px green;
    }
}



/* =========================
   TOP SECTION
========================= */

.top-dashboard-section {

    display: flex;

    flex-direction: column; 

    align-items: center;

    gap: 20px;

}


/* Statistics Cards */

.statistics-container {

    display: flex;
    flex-wrap: wrap;

    gap: 25px;

    justify-content: center;

    margin-bottom: 20px;

}


.stats-card {

    background: white;

    border-radius: 10px;

    padding: 15px;

    box-shadow: 0px 3px 6px rgba(0,0,0,0.1);

    min-width: 200px;

    text-align: center;

}


/* =========================
   CHARTS
========================= */


.dashboardChart {

    width:30%;

    min-width:280px;

    padding:15px;

    border-radius:10px;

    box-shadow:0px 3px 6px rgba(0,0,0,0.15);

}


.combined-charts-row {

    display:flex;

    flex-wrap:wrap;

    gap:20px;

    margin-bottom:20px;

}


.combined-chart-container {

    flex:1 1;

    background:white;

    padding:5px;

    border-radius:10px;

    height:300px;

    overflow:hidden;

}


@media screen and (max-width:768px){

    .dashboardChart{

        width:100%;

    }


    .combined-charts-row{

        flex-direction:column;

    }

}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/dashboard.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2OG;;;;AAIH,iBAAiB;AACjB;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;;AAGA,qBAAqB;AACrB;IACI,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,OAAO;AACX;;;AAGA;;2BAE2B;;AAE3B;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;;IAEnB,aAAa;IACb,mBAAmB,MAAM,sBAAsB;IAC/C,uBAAuB;IACvB,mBAAmB;;IAEnB,SAAS;AACb;;;AAGA,iBAAiB;;AAEjB;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA,yBAAyB;;AAEzB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;;AAGA;;2BAE2B;;AAE3B;IACI,UAAU;IACV,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,oCAAoC;AACxC;;AAEA;IACI,UAAU;IACV,mCAAmC;AACvC;;;AAGA;;IAEI;QACI,UAAU;QACV,sCAAsC;IAC1C;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,sCAAsC;IAC1C;AACJ;;;AAGA;;IAEI;QACI,UAAU;QACV,4CAA4C;IAChD;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,4CAA4C;IAChD;AACJ;;;AAGA;;IAEI;QACI,UAAU;QACV,0CAA0C;IAC9C;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,0CAA0C;IAC9C;AACJ;;;;AAIA;;2BAE2B;;AAE3B;;IAEI,aAAa;;IAEb,sBAAsB;;IAEtB,mBAAmB;;IAEnB,SAAS;;AAEb;;;AAGA,qBAAqB;;AAErB;;IAEI,aAAa;IACb,eAAe;;IAEf,SAAS;;IAET,uBAAuB;;IAEvB,mBAAmB;;AAEvB;;;AAGA;;IAEI,iBAAiB;;IAEjB,mBAAmB;;IAEnB,aAAa;;IAEb,uCAAuC;;IAEvC,gBAAgB;;IAEhB,kBAAkB;;AAEtB;;;AAGA;;2BAE2B;;;AAG3B;;IAEI,SAAS;;IAET,eAAe;;IAEf,YAAY;;IAEZ,kBAAkB;;IAElB,uCAAuC;;AAE3C;;;AAGA;;IAEI,YAAY;;IAEZ,cAAc;;IAEd,QAAQ;;IAER,kBAAkB;;AAEtB;;;AAGA;;IAEI,QAAM;;IAEN,gBAAgB;;IAEhB,WAAW;;IAEX,kBAAkB;;IAElB,YAAY;;IAEZ,eAAe;;AAEnB;;;AAGA;;IAEI;;QAEI,UAAU;;IAEd;;;IAGA;;QAEI,qBAAqB;;IAEzB;;AAEJ","sourcesContent":["/* .nav-pills {\n    display: flex;\n    justify-content: center;\n    padding: 10px;\n    border-radius: 8px;\n}\n.nav-pills .nav-link {\n    color: #007bff;\n    font-weight: bold;\n    border-radius: 5px;\n    padding: 10px 20px;\n    transition: 0.3s ease-in-out;\n    margin-right: 10px;\n}\n.nav-pills .nav-link.active {\n    background: #007bff;\n    color: white;\n}\n.nav-pills .nav-link:hover {\n    background: #0056b3;\n    color: white;\n}\n.channel-card {\n    border-radius: 12px;\n    padding: 20px;\n    transition: 0.3s ease-in-out;\n}\n.dashboardChartContainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    gap: 2%;\n}\n\n\n.traffic-container { \n    width: 160px; \n    background: #222; \n    padding: 15px; \n    border-radius: 20px; \n    display: flex; \n    flex-direction: row;   \n    gap: 15px; \n    align-items: center; \n    justify-content: center;\n}\n\n\n\n.light {\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n    opacity: 0.2;\n}\n\n\n\n.red-light {\n    background: red;\n}\n\n\n.yellow-light {\n    background: yellow;\n}\n\n\n.green-light {\n    background: green;\n}\n\n\n .blink-red {\n    opacity: 1;\n    animation: blinkRed 0.8s infinite;\n}\n\n.blink-yellow {\n    opacity: 1;\n    animation: blinkYellow 0.8s infinite;\n}\n\n.blink-green {\n    opacity: 1;\n    animation: blinkGreen 0.8s infinite;\n}\n.traffic-light-center {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n\n\n@keyframes blinkRed {\n\n    0% {\n        opacity: 1;\n        box-shadow: 0 0 20px red, 0 0 40px red;\n    }\n\n    50% {\n        opacity: 0.3;\n        box-shadow: none;\n    }\n\n    100% {\n        opacity: 1;\n        box-shadow: 0 0 20px red, 0 0 40px red;\n    }\n\n}\n\n\n@keyframes blinkYellow {\n\n    0% {\n        opacity: 1;\n        box-shadow: 0 0 20px rgb(244, 244, 3), 0 0 40px rgb(243, 243, 4);\n    }\n\n    50% {\n        opacity: 0.3;\n        box-shadow: none;\n    }\n\n    100% {\n        opacity: 1;\n        box-shadow: 0 0 20px rgb(246, 246, 5), 0 0 40px rgb(241, 241, 6);\n    }\n\n}\n\n\n@keyframes blinkGreen {\n\n    0% {\n        opacity: 1;\n        box-shadow: 0 0 20px rgb(6, 232, 6), 0 0 40px rgb(5, 234, 5);\n    }\n\n    50% {\n        opacity: 0.3;\n        box-shadow: none;\n    }\n\n    100% {\n        opacity: 1;\n        box-shadow: 0 0 20px rgb(5, 244, 5), 0 0 40px rgb(5, 243, 5);\n    }\n\n}\n.statistics-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 25px;\n  justify-content: center;\n  margin-bottom: 20px;\n  margin-top: -25px;\n}\n\n.stats-card {\n  background: white;\n  border-radius: 10px;\n  padding: 15px;\n  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);\n  min-width: 200px;\n  text-align: center;\n}\n\n.dashboardChart {\n    width: 30%; \n    min-width: 280px; \n    padding: 15px;\n    border-radius: 10px;\n    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);\n}\n\n@media screen and (max-width: 1200px) {\n    .dashboardChart {\n        width: 45%; \n    }\n}\n\n@media screen and (max-width: 768px) {\n    .dashboardChart {\n        width: 100%; \n    }\n}\n\n.combined-charts-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.combined-chart-container {\n  flex: 1;\n  width: 100%;\n  background-color: white;\n  padding: 5px;\n  border-radius: 10px;\n  box-shadow: 0px 3px 6px rgba(241, 241, 241, 0.1);\n  height: 300px;\n  overflow: hidden;\n}\n\n.combined-chart-container canvas {\n  width: 100% !important;\n}\n\n@media screen and (max-width: 768px) {\n  .combined-charts-row {\n    flex-direction: column;\n  }\n\n  .combined-chart-container {\n    width: 100%;\n  }\n  .combined-chart-container canvas {\n    min-height: 300px;\n    width: 100% !important;\n  }\n}\n\n\n.top-dashboard-section {\n    display: flex;\n    flex-direction: column;  \n    align-items: center;\n    gap: 20px;\n} */\n\n\n\n/* Channel Tabs */\n.nav-pills {\n    display: flex;\n    justify-content: center;\n    padding: 10px;\n    border-radius: 8px;\n}\n\n.nav-pills .nav-link {\n    color: #007bff;\n    font-weight: bold;\n    border-radius: 5px;\n    padding: 10px 20px;\n    transition: 0.3s ease-in-out;\n    margin-right: 10px;\n}\n\n.nav-pills .nav-link.active {\n    background: #007bff;\n    color: white;\n}\n\n.nav-pills .nav-link:hover {\n    background: #0056b3;\n    color: white;\n}\n\n\n/* Dashboard Layout */\n.dashboardChartContainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    gap: 2%;\n}\n\n\n/* =========================\n   TRAFFIC LIGHT\n========================= */\n\n.traffic-container {\n    width: 160px;\n    background: #222;\n    padding: 15px;\n    border-radius: 20px;\n\n    display: flex;\n    flex-direction: row;     /* Horizontal lights */\n    justify-content: center;\n    align-items: center;\n\n    gap: 15px;\n}\n\n\n/* Light Circle */\n\n.light {\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n    opacity: 0.2;\n}\n\n\n.red-light {\n    background: red;\n}\n\n.yellow-light {\n    background: yellow;\n}\n\n.green-light {\n    background: green;\n}\n\n\n/* Center Traffic Light */\n\n.traffic-light-center {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n}\n\n\n/* =========================\n   BLINK ANIMATION\n========================= */\n\n.blink-red {\n    opacity: 1;\n    animation: blinkRed 0.8s infinite;\n}\n\n.blink-yellow {\n    opacity: 1;\n    animation: blinkYellow 0.8s infinite;\n}\n\n.blink-green {\n    opacity: 1;\n    animation: blinkGreen 0.8s infinite;\n}\n\n\n@keyframes blinkRed {\n\n    0% {\n        opacity: 1;\n        box-shadow: 0 0 20px red, 0 0 40px red;\n    }\n\n    50% {\n        opacity: 0.3;\n        box-shadow: none;\n    }\n\n    100% {\n        opacity: 1;\n        box-shadow: 0 0 20px red, 0 0 40px red;\n    }\n}\n\n\n@keyframes blinkYellow {\n\n    0% {\n        opacity: 1;\n        box-shadow: 0 0 20px yellow, 0 0 40px yellow;\n    }\n\n    50% {\n        opacity: 0.3;\n        box-shadow: none;\n    }\n\n    100% {\n        opacity: 1;\n        box-shadow: 0 0 20px yellow, 0 0 40px yellow;\n    }\n}\n\n\n@keyframes blinkGreen {\n\n    0% {\n        opacity: 1;\n        box-shadow: 0 0 20px green, 0 0 40px green;\n    }\n\n    50% {\n        opacity: 0.3;\n        box-shadow: none;\n    }\n\n    100% {\n        opacity: 1;\n        box-shadow: 0 0 20px green, 0 0 40px green;\n    }\n}\n\n\n\n/* =========================\n   TOP SECTION\n========================= */\n\n.top-dashboard-section {\n\n    display: flex;\n\n    flex-direction: column; \n\n    align-items: center;\n\n    gap: 20px;\n\n}\n\n\n/* Statistics Cards */\n\n.statistics-container {\n\n    display: flex;\n    flex-wrap: wrap;\n\n    gap: 25px;\n\n    justify-content: center;\n\n    margin-bottom: 20px;\n\n}\n\n\n.stats-card {\n\n    background: white;\n\n    border-radius: 10px;\n\n    padding: 15px;\n\n    box-shadow: 0px 3px 6px rgba(0,0,0,0.1);\n\n    min-width: 200px;\n\n    text-align: center;\n\n}\n\n\n/* =========================\n   CHARTS\n========================= */\n\n\n.dashboardChart {\n\n    width:30%;\n\n    min-width:280px;\n\n    padding:15px;\n\n    border-radius:10px;\n\n    box-shadow:0px 3px 6px rgba(0,0,0,0.15);\n\n}\n\n\n.combined-charts-row {\n\n    display:flex;\n\n    flex-wrap:wrap;\n\n    gap:20px;\n\n    margin-bottom:20px;\n\n}\n\n\n.combined-chart-container {\n\n    flex:1;\n\n    background:white;\n\n    padding:5px;\n\n    border-radius:10px;\n\n    height:300px;\n\n    overflow:hidden;\n\n}\n\n\n@media screen and (max-width:768px){\n\n    .dashboardChart{\n\n        width:100%;\n\n    }\n\n\n    .combined-charts-row{\n\n        flex-direction:column;\n\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
